/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetAxisRepresentation } from './WidgetAxisRepresentation';
import {
    WidgetAxisRepresentationFromJSON,
    WidgetAxisRepresentationFromJSONTyped,
    WidgetAxisRepresentationToJSON,
    WidgetAxisRepresentationToJSONTyped,
} from './WidgetAxisRepresentation';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface WidgetCreateRequest
 */
export interface WidgetCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    generatedTitle: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    preset: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    type: string;
    /**
     * 
     * @type {Resolution}
     * @memberof WidgetCreateRequest
     */
    resolution?: Resolution;
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    config?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetCreateRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetCreateRequest
     */
    intervalName: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetCreateRequest
     */
    intervalFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetCreateRequest
     */
    intervalTo?: number;
    /**
     * 
     * @type {Array<WidgetAxisRepresentation>}
     * @memberof WidgetCreateRequest
     */
    axis: Array<WidgetAxisRepresentation>;
}



/**
 * Check if a given object implements the WidgetCreateRequest interface.
 */
export function instanceOfWidgetCreateRequest(value: object): value is WidgetCreateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('generatedTitle' in value) || value['generatedTitle'] === undefined) return false;
    if (!('preset' in value) || value['preset'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('intervalName' in value) || value['intervalName'] === undefined) return false;
    if (!('axis' in value) || value['axis'] === undefined) return false;
    return true;
}

export function WidgetCreateRequestFromJSON(json: any): WidgetCreateRequest {
    return WidgetCreateRequestFromJSONTyped(json, false);
}

export function WidgetCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'generatedTitle': json['generatedTitle'],
        'preset': json['preset'],
        'type': json['type'],
        'resolution': json['resolution'] == null ? undefined : ResolutionFromJSON(json['resolution']),
        'config': json['config'] == null ? undefined : json['config'],
        'position': json['position'] == null ? undefined : json['position'],
        'intervalName': json['intervalName'],
        'intervalFrom': json['intervalFrom'] == null ? undefined : json['intervalFrom'],
        'intervalTo': json['intervalTo'] == null ? undefined : json['intervalTo'],
        'axis': ((json['axis'] as Array<any>).map(WidgetAxisRepresentationFromJSON)),
    };
}

export function WidgetCreateRequestToJSON(json: any): WidgetCreateRequest {
    return WidgetCreateRequestToJSONTyped(json, false);
}

export function WidgetCreateRequestToJSONTyped(value?: WidgetCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'generatedTitle': value['generatedTitle'],
        'preset': value['preset'],
        'type': value['type'],
        'resolution': ResolutionToJSON(value['resolution']),
        'config': value['config'],
        'position': value['position'],
        'intervalName': value['intervalName'],
        'intervalFrom': value['intervalFrom'],
        'intervalTo': value['intervalTo'],
        'axis': ((value['axis'] as Array<any>).map(WidgetAxisRepresentationToJSON)),
    };
}

